import {makeAutoObservable} from "mobx"
import {tenantStore} from "./TenantStore";

class NavigationStore {
    get activePath(): string {
        return this._activePath;
    }

    set activePath(value: string) {
        this._activePath = value;
    }

    private _activePath: string = ''
    constructor() {
        makeAutoObservable(this)
    }

    setActivePath(request: Request) {
        const url = new URL(request.url);

        const tenantId = tenantStore.tenant || ""
        this._activePath = url.pathname.substring(`/${tenantId}`.length);
    }
}

const navigationStore = new NavigationStore()

export {
    navigationStore
}
